import { render, staticRenderFns } from "./SBirthDayPicker.vue?vue&type=template&id=600bef74&scoped=true"
import script from "./SBirthDayPicker.vue?vue&type=script&lang=js"
export * from "./SBirthDayPicker.vue?vue&type=script&lang=js"
import style0 from "./SBirthDayPicker.vue?vue&type=style&index=0&id=600bef74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600bef74",
  null
  
)

export default component.exports